import React from 'react';
import { Flex, Image } from '@skin-seoul/design-system';
import { useProductCard } from '../ProductCardContext';

const ProductImage = () => {
  const { productImage, name } = useProductCard();

  return (
    <Flex align="center" height="100%" justify="center" width="100%" minWidth="0">
      <Image
        alt={name}
        width="100%"
        height="100%"
        objectFit="contain"
        src={productImage}
        style={{ mixBlendMode: 'darken' }}
        maxWidth="100%"
        loading="lazy"
        maxHeight="100%"
      />
    </Flex>
  );
};

export default ProductImage;
